<template>
  <CRow>
    <CCol>
      <label class="font-weight-bold text-crimson">Thông tin thêm:</label>
      <ul class="pl-4" v-if="Object.keys(row).length">
        <li>
          <strong>Hình thức mua bán: </strong>
          {{ row.form_name }}
        </li>
        <li>
          <strong>Loại hình bất động sản: </strong>
          {{ row.type_name }}
        </li>
        <li>
          <strong>Giá xem tin: </strong>
          {{ fNumber(row.view_price) }} (coin)
        </li>
        <li>
          <strong>Lượt xem: </strong>
          {{ fNumber(row.view_count) }}
        </li>
        <li>
          <strong>Lượt like: </strong>
          {{ fNumber(row.like_count) }}
        </li>
        <li>
          <strong>Ngày cập nhật: </strong>
          {{ updateAt }}
        </li>
      </ul>
    </CCol>
  </CRow>
</template>

<script>
import moment from 'moment'
import {format} from '@/mixins/format'

export default {
  name: "ExpandInfoList",
  mixins: [
    format
  ],
  props: {
    row: {
      type: Object
    }
  },
  computed: {
    updateAt() {
      return moment(this.row.updated_at).format('YYYY/MM/DD - HH:mm:ss')
    }
  }
}
</script>

<style scoped></style>
